import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/client/business", { offset, filter });
};

export const get = async (id: string) => {
  return httpRequest.get(`/api/client/business/${id}`);
};

export const sme = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/client/business/sme", { offset, filter });
};
